// frontend/src/components/public/PortfolioFooter.tsx
import React from 'react';
import { Box, Typography } from '@mui/material';

interface PortfolioFooterProps {
  logo?: string;
  portfolioTitle?: string;
  contactName?: string;
  theme?: {
    primaryColor: string;
    accentColor: string;
  };
}

const PortfolioFooter: React.FC<PortfolioFooterProps> = ({ 
  logo, 
  portfolioTitle,
  contactName,
  theme 
}) => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      sx={{
        bgcolor: theme?.primaryColor || '#2C3E50',
        color: '#ffffff',
        py: 6,
        px: { xs: 3, md: 6 },
        mt: 8
      }}
    >
      <Box
        sx={{
          maxWidth: '1400px',
          mx: 'auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 3
        }}
      >
        {/* Logo */}
        {logo && (
          <Box
            component="img"
            src={logo}
            alt="Logo"
            sx={{
              maxHeight: 80,
              maxWidth: 250,
              objectFit: 'contain',
              filter: 'brightness(0) invert(1)' // Makes logo white
            }}
          />
        )}

{contactName ? (
  <Typography
    variant="h6"
    sx={{
      fontSize: '1.1rem',
      fontWeight: 600,
      color: '#ffffff',
      textAlign: 'center'
    }}
  >
    {portfolioTitle}&nbsp;prepared for&nbsp;{contactName}
  </Typography>
) : (
  <Typography
    variant="h6"
    sx={{
      fontSize: '1.1rem',
      fontWeight: 600,
      color: '#ffffff',
      textAlign: 'center'
    }}
  >
    {portfolioTitle}
  </Typography>
)}

        {/* Copyright */}
        <Typography
          variant="body2"
          sx={{
            fontSize: '0.9rem',
            color: 'rgba(255, 255, 255, 0.7)',
            textAlign: 'center'
          }}
        >
          © {currentYear} {portfolioTitle || 'All rights reserved'}
        </Typography>
      </Box>
    </Box>
  );
};

export default PortfolioFooter;